import { useEffect, useState } from "react";
import { getSessionStrict, loginUrl, readUserCenter } from "../lib/identity";
import { controller, type CentralResult } from "./central-progress-core.mjs";

const messages: Record<string, string> = {
  idle: "",
  loading: "正在讀取今日安排與核驗紀錄…",
  anonymous: "登入後可查看自己的安排與評閱紀錄。",
  identity_changed: "帳號已切換，請重新讀取。",
  date_changed: "今日日期已更新，請重新讀取。",
  unavailable: "目前無法核對最新紀錄。已有資料會保留，請稍後重試。",
};
const statuses: Record<string, string> = {
  completed: "線上部分已有完成證據，請自查當日要求", in_progress: "已有學習紀錄",
  no_evidence: "尚未查到有效完成紀錄", record_only: "依當日要求自行檢查",
  needs_reconciliation: "部分紀錄待核對", source_unverified: "來源待核對",
};
export function CentralProgress({ onRead, onBattle }: { onRead: (id: number) => void; onBattle: () => void }) {
  const [result, setResult] = useState<CentralResult>({ state: "idle" });
  const [client] = useState(() => controller({ identity: () => ({ getSession: getSessionStrict, api: readUserCenter }), render: setResult }));
  useEffect(() => {
    const clear = () => client.clear();
    window.addEventListener("bdfz:session-invalidated", clear);
    window.addEventListener("analects-account-changed", clear);
    return () => { client.clear(); window.removeEventListener("bdfz:session-invalidated", clear); window.removeEventListener("analects-account-changed", clear); };
  }, [client]);
  return <section className="central-progress" aria-label="今日安排與已核驗紀錄">
    <header><h2>今日</h2><button disabled={result.state === "loading"} onClick={() => void client.refresh()}>{result.view ? "更新紀錄" : "讀取我的紀錄"}</button></header>
    {result.state !== "idle" && <p role="status">{messages[result.state] || `北京日期 ${result.view?.day} · ${result.view?.year} 學年`}</p>}
    {result.state === "anonymous" && <a href={loginUrl()}>登入 My</a>}
    {result.state === "ready" && result.view && <>
      <div className="central-gates">{result.view.progress.map(item => <article key={item.id}><h3>{item.title}</h3><strong>{item.current}</strong><p>{item.unit}</p><p>{item.verified ? item.status === "completed" ? "已符合原有完成條件" : "依原有條件繼續學習" : "尚未核齊，保留原有結果"}</p></article>)}</div>
      <h3>今日安排</h3>{!result.view.tasks.length && <p>今日沒有列入《論語》四站的任務，可以按章節或主題繼續研讀。</p>}
      <div className="central-tasks">{result.view.tasks.map(task => <article key={task.taskId}><h4>{task.title}</h4><p>{task.action}</p>{task.details.length > 0 && <ul>{task.details.map((detail, i) => <li key={i}>{detail}</li>)}</ul>}<p><strong>完成自查：</strong>{task.completionCheck}</p><small>{statuses[task.scoringStatus] || "以原任務要求與已審閱結果為準"}</small><div>{task.chapterIds.map(id => <button key={id} onClick={() => onRead(Number(id))}>研讀對應章句</button>)}{task.mode === "battle" && <button onClick={onBattle}>進入義戰</button>}</div></article>)}</div>
      <p className="workbench-scope">此處直接顯示 My 的核驗結果，不把瀏覽、對談次數或遊戲數值換算成正式成績。完整歷史與逐項評閱仍可在右上角「我的」查看。</p>
    </>}
  </section>;
}
